import { useEffect, useState } from 'react'
import { Alert, CircularProgress, Container, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import OnlyWebView from './OnlyWebView'

export default function ExamRegistration() {
   const [loading, setLoading] = useState(true)
   const [message, setMessage] = useState(null)

   const navigate = useNavigate()
   const API_BASE_URL = process.env.REACT_APP_API_URL

   const [platform, setPlatform] = useState('')
   useEffect(() => {
      const ua = navigator.userAgent || navigator.vendor || window.opera
      // Deteksi WebView Android (ada "wv")
      if (
         // true
         /wv/.test(ua) ||
         /\bFBAN\b|\bFBAV\b|\bInstagram\b|\bLine\b/i.test(ua)
      ) {
         setPlatform('WebView')

         // if open in webview
         const urlParams = new URLSearchParams(window.location.search)
         const examId = urlParams.get('exam_id')
         const participantId = urlParams.get('exam_participant_id')

         if (!examId || !participantId) {
            setMessage({ type: 'error', text: 'Invalid registration link' })
            setLoading(false)
            return
         }

         // Kirim payload ke backend
         axios
            .post(API_BASE_URL + '/exam/registration', {
               exam_id: examId,
               exam_participant_id: participantId,
            })
            .then((res) => {
               if (res.data.token) {
                  sessionStorage.setItem('exam_token', res.data.token)
                  navigate('/exam/start')
                  console.log('navigate to start')
               } else {
                  setMessage({ type: 'error', text: 'Gagal registrasi' })
               }
            })
            .catch((err) => {
               setMessage({ type: 'error', text: 'Server error' + err })
            })
            .finally(() => setLoading(false))
      } else {
         setPlatform('Browser')
         navigate('/exam/only_web_view')
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   return (
      <Container sx={{ mt: 5, textAlign: 'center' }}>
         {platform === 'WebView' ? (
            <>
               {loading ? (
                  <CircularProgress />
               ) : (
                  message && (
                     <>
                        <Alert severity={message?.type}>
                           <Typography variant="h6">{message?.text}</Typography>
                        </Alert>
                     </>
                  )
               )}
            </>
         ) : (
            <>
               <OnlyWebView />
            </>
         )}
      </Container>
   )
}
